// Local storage helpers - structured so Supabase can be swapped in later.

const KEY_DAILY = "cs.daily.answers";
const KEY_CUSTOM = "cs.custom.games";
const KEY_LAST_RESULT = "cs.daily.lastResult";

export const loadDailyAnswers = () => {
  try { return JSON.parse(localStorage.getItem(KEY_DAILY) || "[]"); } catch { return []; }
};
export const saveDailyAnswers = (answers) => {
  localStorage.setItem(KEY_DAILY, JSON.stringify(answers));
};
export const clearDaily = () => localStorage.removeItem(KEY_DAILY);

export const saveLastResult = (result) => {
  localStorage.setItem(KEY_LAST_RESULT, JSON.stringify(result));
};
export const loadLastResult = () => {
  try { return JSON.parse(localStorage.getItem(KEY_LAST_RESULT) || "null"); } catch { return null; }
};

// Custom games -- keyed by code (e.g. CS-8472)
export const loadCustomGames = () => {
  try { return JSON.parse(localStorage.getItem(KEY_CUSTOM) || "{}"); } catch { return {}; }
};
export const saveCustomGame = (game) => {
  const games = loadCustomGames();
  games[game.code] = game;
  localStorage.setItem(KEY_CUSTOM, JSON.stringify(games));
};
export const getCustomGame = (code) => {
  const games = loadCustomGames();
  return games[code] || null;
};

export const generateCode = () => {
  const n = Math.floor(1000 + Math.random() * 9000);
  return `CS-${n}`;
};

export const resetAll = () => {
  localStorage.removeItem(KEY_DAILY);
  localStorage.removeItem(KEY_CUSTOM);
  localStorage.removeItem(KEY_LAST_RESULT);
};
